import CreateSmartTip from './CreateSmartTip';

export default CreateSmartTip;
